import { createFileRoute } from '@tanstack/react-router'
import { ModulesSection } from '../../../features/settings/admin-sections'
import { requireSection } from '../../../features/settings/guards'

export const Route = createFileRoute('/_app/settings/modules')({
  staticData: { crumb: 'settingsSection' },
  beforeLoad: ({ context }) => requireSection(context.session, 'modules'),
  component: ModulesSection,
})
